import "@aws-amplify/ui-react/styles.css";
import { Heading } from '@chakra-ui/react'
import React from "react";
import { Explore } from "../controls/Explore";
import BasePage from "../controls/BasePage";
import { LoadingBlock } from "../controls/LoadingBlock";
import PageTitle from "../controls/PageTitle";
import { LoadingPage } from "../controls/LoadingPage";

class Teams extends BasePage {
    render() {
        if (this.state.data == null) {
            return <LoadingPage pageTitle="Seasons and Teams" />;
        }
        return (<>
            <PageTitle>Seasons and Teams</PageTitle>
            <Explore siteData={this.state.data}></Explore>
        </>)
    }
}

export default Teams;